import React from "react";
import {
  AccountBalanceOutlined,
  AccountBalanceWalletOutlined,
  Description,
  DomainOutlined,
  ModeStandbyRounded,
  ToggleOnOutlined,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";

import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";
import { useAdjustmentDetailContext } from "contexts/PaymentContexts/AdjustmentContext";
import OpenInNewTab from "components/Shared/OpenInNewTab";
import { useAuth } from "hooks";

const AdjustmentBasicDetail = () => {
  const { adjustmentDetail, loadingAdjustment } = useAdjustmentDetailContext();
  const { isVendor } = useAuth();
  return !loadingAdjustment ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <AccountBalanceOutlined color="primary" />}
            title="Account"
            subtitle={adjustmentDetail?.account?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <DomainOutlined color="primary" />}
            title="Entity"
            subtitle={adjustmentDetail?.entity?.name || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <AccountBalanceWalletOutlined color="primary" />}
            title="Adjustment ID"
            subtitle={adjustmentDetail?.adjustmentID || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <AccountBalanceWalletOutlined color="primary" />}
            title="Type"
            subtitle={adjustmentDetail?.type || "N/A"}
          />
        </Grid>

        <Grid item md={3}>
          <InformationTile
            title="Linked Type"
            icon={() => <ModeStandbyRounded color="primary" />}
            subtitle={
              adjustmentDetail?.sourceModel === "VendorProfile"
                ? "Vendor Profile"
                : adjustmentDetail?.sourceModel === "Customer"
                ? "Customer Profile"
                : adjustmentDetail?.sourceModel === "Contractor"
                ? "Contractor Profile"
                : "Unknown Profile"
            }
          />
        </Grid>

        <Grid item md={3}>
          <InformationTile
            title="Profile Name"
            icon={() => <ModeStandbyRounded color="primary" />}
            subtitle={
              adjustmentDetail?.sourceModel === "VendorProfile"
                ? adjustmentDetail?.sourceModelRef?.vendor?.name
                : adjustmentDetail?.sourceModel === "Customer"
                ? adjustmentDetail?.sourceModelRef?.customerUser?.name
                : adjustmentDetail?.sourceModel === "Contractor"
                ? adjustmentDetail?.sourceModelRef?.name
                : "Unknown Profile"
            }
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <AccountBalanceWalletOutlined color="primary" />}
            title="Payment Account Name"
            subtitle={
              adjustmentDetail?.paymentAccount?._id ? (
                isVendor ? (
                  <span>{adjustmentDetail.paymentAccount.accountName}</span>
                ) : (
                  <OpenInNewTab
                    label={adjustmentDetail.paymentAccount.accountName}
                    link={`/app/crm/payment-account/${adjustmentDetail.paymentAccount._id}/detail`}
                    disableIcon
                  />
                )
              ) : (
                "N/A"
              )
            }
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <AccountBalanceWalletOutlined color="primary" />}
            title="Amount"
            subtitle={adjustmentDetail?.amount?.toFixed(2) || "N/A"}
          />
        </Grid>

        <Grid item xs={3}>
          <InformationTile
            icon={() => <ToggleOnOutlined color="primary" />}
            title="Status"
          >
            <Status isActive={adjustmentDetail?.isActive} />
          </InformationTile>
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <Description color="primary" />}
            title="Description"
            subtitle={adjustmentDetail?.description || "N/A"}
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default AdjustmentBasicDetail;
